// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"aac0a20d","768":"effacaa6"}[chunkId] + ".css";
};